import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Button } from './ui/button';
import { Sparkles, X } from 'lucide-react';

export function WhatsNewPopup({ isOpen, onClose, feature }) {
  if (!feature) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-slate-900 border-slate-800 max-w-sm mx-auto">
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-red-500 to-pink-600 flex items-center justify-center">
              <Sparkles className="h-5 w-5 text-white" />
            </div>
            <DialogTitle className="text-white font-bold">
              {feature.title}
            </DialogTitle>
          </div>
        </DialogHeader>
        
        <div className="mt-4">
          <p className="text-slate-300 text-sm leading-relaxed">
            {feature.description}
          </p>
        </div>
        
        <div className="mt-6">
          <Button 
            onClick={onClose}
            className="w-full bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white"
          >
            Got it!
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

/**
 * Red notification dot component
 * Shows in the top-right corner of parent element
 */
export function NewFeatureDot({ onClick, className = "" }) {
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
      className={`absolute -top-1 -right-1 z-10 cursor-pointer ${className}`}
      role="status"
      aria-label="New feature available"
    >
      <span className="relative flex h-4 w-4">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
        <span className="relative inline-flex rounded-full h-4 w-4 bg-red-500 border-2 border-slate-900"></span>
      </span>
    </div>
  );
}

/**
 * Smaller dot for bottom nav bar
 */
export function NewFeatureDotSmall({ onClick, className = "" }) {
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
      className={`absolute -top-0.5 -right-0.5 z-10 cursor-pointer ${className}`}
      role="status"
      aria-label="New feature available"
    >
      <span className="relative flex h-2.5 w-2.5">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
        <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500"></span>
      </span>
    </div>
  );
}

export default WhatsNewPopup;
